import macrobenthosImg1 from 'img/eco-environmental-survey/Mb.webp';
import macrobenthosImg2 from 'img/eco-environmental-survey/Mba.webp';
// import macrobenthosImg3 from 'img/eco-environmental-survey/placeholder.webp';
import macrobenthosImg3 from 'img/eco-environmental-survey/Ma.webp';
import macrobenthosImg4 from 'img/eco-environmental-survey/Al.webp';
// import macrobenthosImg5 from 'img/eco-environmental-survey/placeholder.webp';
import macrobenthosImg5 from 'img/eco-environmental-survey/Gb.webp';
import macrobenthosImg6 from 'img/eco-environmental-survey/Ta.webp';
import macrobenthosImg7 from 'img/eco-environmental-survey/It.webp';
import macrobenthosImg8 from 'img/eco-environmental-survey/Sb.webp';
// import macrobenthosImg9 from 'img/eco-environmental-survey/placeholder.webp';
import macrobenthosImg9 from 'img/eco-environmental-survey/Sl.webp';
import macrobenthosImg10 from 'img/eco-environmental-survey/Pp.webp';
// import macrobenthosImg11 from 'img/eco-environmental-survey/placeholder.webp';
// import macrobenthosImg12 from 'img/eco-environmental-survey/placeholder.webp';
import macrobenthosImg11 from 'img/eco-environmental-survey/Hp.webp';
import macrobenthosImg12 from 'img/eco-environmental-survey/Me.webp';

import { GRAPH_COLOR } from 'data/common';

import waterMarkImg from 'img/icon/changhua.svg';

export const commonOptions = {
  title: {
    show: false,
  },
  legend: {
    show: false,
  },
  toolbox: {
    show: true,
    showTitle: true,
    feature: {
      dataZoom: {
        yAxisIndex: 'none',
        title: {
          zoom: '放大',
          back: '放大還原',
        },
      },
      magicType: {
        type: ['bar', 'line'],
        title: {
          bar: '長條圖',
          line: '折線圖',
        },
      },
      restore: { title: '重新整理' },
    },
  },
  dataZoom: [
    {
      start: 20,
      end: 80,
      zoomOnMouseWheel: false,
    },
    {
      type: 'slider',
      selectedDataBackground: {
        areaStyle: {
          color: 'rgba(1, 116, 187, 0.7)',
          opacity: 1,
        },
        lineStyle: {
          color: 'rgba(189, 189, 189, 1)',
        },
      },
      dataBackground: {
        lineStyle: {
          color: 'rgba(189, 189, 189, 1)',
        },
        areaStyle: {
          color: 'rgba(1, 116, 187, 0)',
        },
      },
      borderColor: 'rgba(224, 224, 224, 1)',
      handleStyle: {
        borderColor: 'rgba(224, 224, 224, 1)',
      },
      moveHandleStyle: {
        color: 'rgba(1, 116, 187, 0.5)',
      },
      emphasis: {
        moveHandleStyle: {
          color: 'rgba(1, 116, 187, 1)',
        },
        handleStyle: {
          borderColor: 'rgba(1, 116, 187, 1)',
        },
      },
      backgroundColor: 'rgba(255, 255, 255, 0)',
      fillerColor: 'rgba(1, 116, 187, 0)',
      brushStyle: {
        color: 'rgba(1, 116, 187, 0)',
      },
    },
  ],
  color: GRAPH_COLOR.legend.multiple,
  tooltip: {
    trigger: 'axis',
    backgroundColor: GRAPH_COLOR.tooltip.background.dark,
  },
};

export const macrobenthosList = [
  {
    id: '1',
    trivialName: '短指和尚蟹',
    scientificName: 'Mictyris brevidactylus',
    taxonomy: '十足目 和尚蟹科',
    characteristic:
      '成蟹背甲多為淡藍色、外表大致成圓球狀、步足基部呈紅色、螯足為淡黃色，幼蟹背甲多為黑色且步足基部不呈紅色。於退潮時成蟹會成群移動至灘地上的潮溪邊覓食，數量從數十到數百皆有，雌蟹與幼蟹傾向於在灘地表層下覓食，常在灘地上形成由擬糞構成的通道。',
    distributionArea:
      '台灣西部海岸、澎湖、金門、馬祖皆可發現，多分佈於中低潮位的灘地。',
    img: macrobenthosImg1,
    photographer: '李坤璋',
    reference: [
      {
        id: '1-1',
        category: '圖書',
        author: '王嘉祥、劉烘昌',
        title: '台灣海邊常見的螃蟹 Common seashore crabs of Taiwan',
        publicationPlace: '台北',
        publisher: '台灣省立博物館',
        year: '1996',
      },
      {
        id: '1-2',
        category: '圖書',
        author: '李榮祥',
        title: '台灣賞蟹情報',
        publicationPlace: '台北',
        publisher: '',
        year: '2008',
      },
      {
        id: '1-3',
        category: '圖書',
        author: '林惠真、宋文汀、蘇珊慧',
        title: '台中縣海岸濕地生態教室',
        publicationPlace: '台中',
        publisher: '',
        year: '2003',
      },
      {
        id: '1-4',
        category: '圖書',
        author: '林惠真、曾于芳',
        title: '話說高美',
        publicationPlace: '台中',
        publisher: '',
        year: '2014',
      },
      {
        id: '1-5',
        category: '圖書',
        author: 'Shih, H.T., Chan, B. K. K., Teng, S. J., Wong, K. J. H.',
        title: '台灣蟹類誌II（沙蟹總科）',
        publicationPlace: '',
        publisher: '國立中興大學',
        year: '',
      },
    ],
  },
  {
    id: '2',
    trivialName: '萬歲大眼蟹',
    scientificName: 'Macrophthalmus banzai',
    taxonomy: '十足目 大眼蟹科',
    characteristic:
      '背甲形狀呈長方形且顏色為灰褐色，眼柄細長，有一對大小相同之大螯，螯指向下彎曲，揮螯的動作為同時高舉大螯，像是高喊萬歲一樣。',
    distributionArea:
      '台灣西部與東北部海岸、澎湖、金門皆可發現，多分佈於低潮位或有較多積水之泥灘地。',
    img: macrobenthosImg2,
    photographer: '洪昆瑨',
    reference: [
      {
        id: '2-1',
        category: '圖書',
        author: '王嘉祥、劉烘昌',
        title: '台灣海邊常見的螃蟹 Common seashore crabs of Taiwan',
        publicationPlace: '台北',
        publisher: '台灣省立博物館',
        year: '1996',
      },
      {
        id: '2-2',
        category: '圖書',
        author: '李榮祥',
        title: '台灣賞蟹情報',
        publicationPlace: '台北',
        publisher: '',
        year: '2008',
      },
      {
        id: '2-3',
        category: '圖書',
        author: '林惠真、宋文汀、蘇珊慧',
        title: '台中縣海岸濕地生態教室',
        publicationPlace: '台中',
        publisher: '',
        year: '2003',
      },
      {
        id: '2-4',
        category: '圖書',
        author: '林惠真、曾于芳',
        title: '話說高美',
        publicationPlace: '台中',
        publisher: '',
        year: '2014',
      },
      {
        id: '2-5',
        category: '圖書',
        author: 'Shih, H.T., Chan, B. K. K., Teng, S. J., Wong, K. J. H.',
        title: '台灣蟹類誌II（沙蟹總科）',
        publicationPlace: '',
        publisher: '國立中興大學',
        year: '',
      },
    ],
  },
  {
    id: '3',
    trivialName: '短身大眼蟹',
    scientificName: 'Macrophthalmus abbreviatus',
    taxonomy: '十足目 和尚蟹科',
    characteristic:
      '背甲形狀呈長方形且背甲寬約為背甲長度的兩倍、顏色為藍色或灰褐色，眼柄細長，有一對大小相同之大螯、掌節有許多凸起的顆粒，螯指向下彎曲且螯指間會形成空隙，大螯顏色為藍色、灰褐色或暗紫色。',
    distributionArea:
      '台灣西部海岸、澎湖、金門皆可發現，多分佈於有積水且偏沙質的灘地。',
    img: macrobenthosImg3,
    photographer: '',
    reference: [
      {
        id: '3-1',
        category: '圖書',
        author: '王嘉祥、劉烘昌',
        title: '台灣海邊常見的螃蟹 Common seashore crabs of Taiwan',
        publicationPlace: '台北',
        publisher: '台灣省立博物館',
        year: '1996',
      },
      {
        id: '3-2',
        category: '圖書',
        author: '李榮祥',
        title: '台灣賞蟹情報',
        publicationPlace: '台北',
        publisher: '',
        year: '2008',
      },
      {
        id: '3-3',
        category: '圖書',
        author: '林惠真、宋文汀、蘇珊慧',
        title: '台中縣海岸濕地生態教室',
        publicationPlace: '台中',
        publisher: '',
        year: '2003',
      },
      {
        id: '3-4',
        category: '圖書',
        author: '林惠真、曾于芳',
        title: '話說高美',
        publicationPlace: '台中',
        publisher: '',
        year: '2014',
      },
      {
        id: '3-5',
        category: '圖書',
        author: 'Shih, H.T., Chan, B. K. K., Teng, S. J., Wong, K. J. H.',
        title: '台灣蟹類誌II（沙蟹總科）',
        publicationPlace: '',
        publisher: '國立中興大學',
        year: '',
      },
    ],
  },
  {
    id: '4',
    trivialName: '乳白南方招潮',
    scientificName: 'Austruca lactea',
    taxonomy: '十足目 沙蟹科',
    characteristic:
      '背甲寬約1-1.5公分，背甲與螯足、步足皆為白色，背甲顏色在陰天、日落、或受到壓力的情況下變黑。雄蟹具有一特化之大螯，用於求偶與捍衛領域等，且在求偶季會在洞口處以泥土建造弧塔。',
    distributionArea:
      '台灣西部與東北部海岸、澎湖、金門、馬祖皆可發現，在台灣屬於非常常見的物種。',
    img: macrobenthosImg4,
    photographer: '李坤璋',
    reference: [
      {
        id: '4-1',
        category: '圖書',
        author: '王嘉祥、劉烘昌',
        title: '台灣海邊常見的螃蟹 Common seashore crabs of Taiwan',
        publicationPlace: '台北',
        publisher: '台灣省立博物館',
        year: '1996',
      },
      {
        id: '4-2',
        category: '圖書',
        author: '李榮祥',
        title: '台灣賞蟹情報',
        publicationPlace: '台北',
        publisher: '',
        year: '2008',
      },
      {
        id: '4-3',
        category: '圖書',
        author: '林惠真、宋文汀、蘇珊慧',
        title: '台中縣海岸濕地生態教室',
        publicationPlace: '台中',
        publisher: '',
        year: '2003',
      },
      {
        id: '4-4',
        category: '圖書',
        author: '林惠真、曾于芳',
        title: '話說高美',
        publicationPlace: '台中',
        publisher: '',
        year: '2014',
      },
      {
        id: '4-5',
        category: '圖書',
        author: 'Shih, H.T., Chan, B. K. K., Teng, S. J., Wong, K. J. H.',
        title: '台灣蟹類誌II（沙蟹總科）',
        publicationPlace: '',
        publisher: '國立中興大學',
        year: '',
      },
    ],
  },
  {
    id: '5',
    trivialName: '北方丑招潮',
    scientificName: 'Gelasimus borealis',
    taxonomy: '十足目 沙蟹科',
    characteristic:
      '背甲寬約1-2公分，背甲中央有一個類似”H”的溝痕，背甲顏色從白色、灰色、淺棕色到深棕色都有。雄蟹具有一特化之大螯，大螯顏色為橘色或黃色，外緣具有許多顆粒狀突起，且不可動指有一個明顯的凹陷。',
    distributionArea:
      '台灣西部、西南部與東北部海岸、澎湖、金門、馬祖皆可發現，多分佈於低潮位的泥質灘地或潮溪附近。',
    img: macrobenthosImg5,
    photographer: '',
    reference: [
      {
        id: '5-1',
        category: '圖書',
        author: '王嘉祥、劉烘昌',
        title: '台灣海邊常見的螃蟹 Common seashore crabs of Taiwan',
        publicationPlace: '台北',
        publisher: '台灣省立博物館',
        year: '1996',
      },
      {
        id: '5-2',
        category: '圖書',
        author: '李榮祥',
        title: '台灣賞蟹情報',
        publicationPlace: '台北',
        publisher: '',
        year: '2008',
      },
      {
        id: '5-3',
        category: '圖書',
        author: '林惠真、宋文汀、蘇珊慧',
        title: '台中縣海岸濕地生態教室',
        publicationPlace: '台中',
        publisher: '',
        year: '2003',
      },
      {
        id: '5-4',
        category: '圖書',
        author: '林惠真、曾于芳',
        title: '話說高美',
        publicationPlace: '台中',
        publisher: '',
        year: '2014',
      },
      {
        id: '5-5',
        category: '圖書',
        author: 'Shih, H.T., Chan, B. K. K., Teng, S. J., Wong, K. J. H.',
        title: '台灣蟹類誌II（沙蟹總科）',
        publicationPlace: '',
        publisher: '國立中興大學',
        year: '',
      },
    ],
  },
  {
    id: '6',
    trivialName: '弧邊管招潮',
    scientificName: 'Tubuca arcuata',
    taxonomy: '十足目 沙蟹科',
    characteristic:
      '背甲光滑呈梯形且明顯拱起；背甲顏色主要為黑或深褐色、有白或淡黃色的網狀紋路，且體色多變，大螯外緣具有許多顆粒狀突起、螯指粗長；大螯基部為橘紅色、螯指為白色。幼體的背甲顏色為黑色或藍色，且眼柄為橘色。',
    distributionArea:
      '台灣西部與東北部海岸、澎湖、金門皆可發現，多分佈於泥質灘地或紅樹林附近。',
    img: macrobenthosImg6,
    photographer: '李坤璋',
    reference: [
      {
        id: '6-1',
        category: '圖書',
        author: '王嘉祥、劉烘昌',
        title: '台灣海邊常見的螃蟹 Common seashore crabs of Taiwan',
        publicationPlace: '台北',
        publisher: '台灣省立博物館',
        year: '1996',
      },
      {
        id: '6-2',
        category: '圖書',
        author: '李榮祥',
        title: '台灣賞蟹情報',
        publicationPlace: '台北',
        publisher: '',
        year: '2008',
      },
      {
        id: '6-3',
        category: '圖書',
        author: '林惠真、宋文汀、蘇珊慧',
        title: '台中縣海岸濕地生態教室',
        publicationPlace: '台中',
        publisher: '',
        year: '2003',
      },
      {
        id: '6-4',
        category: '圖書',
        author: '林惠真、曾于芳',
        title: '話說高美',
        publicationPlace: '台中',
        publisher: '',
        year: '2014',
      },
      {
        id: '6-5',
        category: '圖書',
        author: 'Shih, H.T., Chan, B. K. K., Teng, S. J., Wong, K. J. H.',
        title: '台灣蟹類誌II（沙蟹總科）',
        publicationPlace: '',
        publisher: '國立中興大學',
        year: '',
      },
    ],
  },
  {
    id: '7',
    trivialName: '淡水泥蟹',
    scientificName: 'Ilyoplax tansuiensis',
    taxonomy: '十足目 毛帶蟹科',
    characteristic:
      '背甲形狀接近於長方形、眼柄較粗，有明顯的眼窩外齒。雄蟹螯足的腕節較長，從背面看有一個突起。背甲與步足呈灰褐色且有暗褐色的斑點，螯足的指節為白色。在灘地上覓食時，會同時以一隻螯足上舉、另一隻螯足向外平舉的方式揮螯，然後側向行走數步後同時放下。',
    distributionArea:
      '台灣西部海岸與金門皆可發現，多分佈於泥質灘地或紅樹林附近。',
    img: macrobenthosImg7,
    photographer: '李坤璋',
    reference: [
      {
        id: '7-1',
        category: '圖書',
        author: '王嘉祥、劉烘昌',
        title: '台灣海邊常見的螃蟹 Common seashore crabs of Taiwan',
        publicationPlace: '台北',
        publisher: '台灣省立博物館',
        year: '1996',
      },
      {
        id: '7-2',
        category: '圖書',
        author: '李榮祥',
        title: '台灣賞蟹情報',
        publicationPlace: '台北',
        publisher: '',
        year: '2008',
      },
      {
        id: '7-3',
        category: '圖書',
        author: '林惠真、宋文汀、蘇珊慧',
        title: '台中縣海岸濕地生態教室',
        publicationPlace: '台中',
        publisher: '',
        year: '2003',
      },
      {
        id: '7-4',
        category: '圖書',
        author: '林惠真、曾于芳',
        title: '話說高美',
        publicationPlace: '台中',
        publisher: '',
        year: '2014',
      },
      {
        id: '7-5',
        category: '圖書',
        author: 'Shih, H.T., Chan, B. K. K., Teng, S. J., Wong, K. J. H.',
        title: '台灣蟹類誌II（沙蟹總科）',
        publicationPlace: '',
        publisher: '國立中興大學',
        year: '',
      },
    ],
  },
  {
    id: '8',
    trivialName: '雙扇股窗蟹',
    scientificName: 'Scopimera bitympana',
    taxonomy: '十足目 毛帶蟹科',
    characteristic:
      '背甲呈圓球狀，螯足的長節內側表面有兩個卵圓形的鼓膜，步足具有稀疏的剛毛，且步足長節具有一卵圓形的鼓膜，可進行氣體交換。體色呈褐色至藍灰色，並有深色的斑點。洞口呈圓形，且雙扇股窗蟹覓食過程產生的擬糞常會以洞口為中心呈放射狀排列。',
    distributionArea:
      '台灣西部海岸與澎湖皆可發現，多分佈於潮間帶高潮線下面的沙質灘地。',
    img: macrobenthosImg8,
    photographer: '李坤璋',
    reference: [
      {
        id: '8-1',
        category: '圖書',
        author: '王嘉祥、劉烘昌',
        title: '台灣海邊常見的螃蟹 Common seashore crabs of Taiwan',
        publicationPlace: '台北',
        publisher: '台灣省立博物館',
        year: '1996',
      },
      {
        id: '8-2',
        category: '圖書',
        author: '李榮祥',
        title: '台灣賞蟹情報',
        publicationPlace: '台北',
        publisher: '',
        year: '2008',
      },
      {
        id: '8-3',
        category: '圖書',
        author: '林惠真、宋文汀、蘇珊慧',
        title: '台中縣海岸濕地生態教室',
        publicationPlace: '台中',
        publisher: '',
        year: '2003',
      },
      {
        id: '8-4',
        category: '圖書',
        author: '林惠真、曾于芳',
        title: '話說高美',
        publicationPlace: '台中',
        publisher: '',
        year: '2014',
      },
      {
        id: '8-5',
        category: '圖書',
        author: 'Shih, H.T., Chan, B. K. K., Teng, S. J., Wong, K. J. H.',
        title: '台灣蟹類誌II（沙蟹總科）',
        publicationPlace: '',
        publisher: '國立中興大學',
        year: '',
      },
    ],
  },
  {
    id: '9',
    trivialName: '長趾股窗蟹',
    scientificName: 'Scopimera longidactyla',
    taxonomy: '十足目 毛帶蟹科',
    characteristic:
      '背甲呈圓球狀，螯足的長節內側表面有一個卵圓形的鼓膜，步足具有稀疏的剛毛，且步足長節具有一卵圓形的鼓膜，可進行氣體交換。體色呈褐色至灰褐色，並有深色的斑點，腹面與步足的內側呈深紅色，是長趾股窗蟹與雙扇股窗蟹外表上最明顯的差異。洞口呈圓形，且長趾股窗蟹覓食過程產生的擬糞常會以洞口為中心呈放射狀排列，有時會與雙扇股窗蟹共域。',
    distributionArea:
      '台灣西部海岸、澎湖與金門皆可發現，多分佈於潮間帶高潮線下面的沙質灘地。',
    img: macrobenthosImg9,
    photographer: '',
    reference: [
      {
        id: '9-1',
        category: '圖書',
        author: '王嘉祥、劉烘昌',
        title: '台灣海邊常見的螃蟹 Common seashore crabs of Taiwan',
        publicationPlace: '台北',
        publisher: '台灣省立博物館',
        year: '1996',
      },
      {
        id: '9-2',
        category: '圖書',
        author: '李榮祥',
        title: '台灣賞蟹情報',
        publicationPlace: '台北',
        publisher: '',
        year: '2008',
      },
      {
        id: '9-3',
        category: '圖書',
        author: '林惠真、宋文汀、蘇珊慧',
        title: '台中縣海岸濕地生態教室',
        publicationPlace: '台中',
        publisher: '',
        year: '2003',
      },
      {
        id: '9-4',
        category: '圖書',
        author: '林惠真、曾于芳',
        title: '話說高美',
        publicationPlace: '台中',
        publisher: '',
        year: '2014',
      },
      {
        id: '9-5',
        category: '圖書',
        author: 'Shih, H.T., Chan, B. K. K., Teng, S. J., Wong, K. J. H.',
        title: '台灣蟹類誌II（沙蟹總科）',
        publicationPlace: '',
        publisher: '國立中興大學',
        year: '',
      },
    ],
  },
  {
    id: '10',
    trivialName: '斑點擬相手蟹',
    scientificName: 'Parasesarma pictum',
    taxonomy: '十足目 相手蟹科',
    characteristic:
      '背甲呈方形，額緣中間略為下凹，有一接近三角形的眼窩外齒，背甲多為深褐色或黑色且有黃色不規則斑點。螯足可動指上緣有15至16或偶有更多卵圓形的顆粒。第一與第二步足、第二與第三步足間的基部皆有毛囊，步足的末端具有稀疏的毛。',
    distributionArea:
      '潮間帶的河口灘地、潮位較高的石礫堆、紅樹林與草澤周邊皆可發現。',
    img: macrobenthosImg10,
    photographer: '',
    reference: [
      {
        id: '10-1',
        category: '圖書',
        author: '王嘉祥、劉烘昌',
        title: '台灣海邊常見的螃蟹 Common seashore crabs of Taiwan',
        publicationPlace: '台北',
        publisher: '台灣省立博物館',
        year: '1996',
      },
      {
        id: '10-2',
        category: '圖書',
        author: '李榮祥',
        title: '台灣賞蟹情報',
        publicationPlace: '台北',
        publisher: '',
        year: '2008',
      },
      {
        id: '10-3',
        category: '圖書',
        author: '林惠真、宋文汀、蘇珊慧',
        title: '台中縣海岸濕地生態教室',
        publicationPlace: '台中',
        publisher: '',
        year: '2003',
      },
      {
        id: '10-4',
        category: '圖書',
        author: '林惠真、曾于芳',
        title: '話說高美',
        publicationPlace: '台中',
        publisher: '',
        year: '2014',
      },
      {
        id: '10-5',
        category: '圖書',
        author: 'Shih, H.T., Chan, B. K. K., Teng, S. J., Wong, K. J. H.',
        title: '台灣蟹類誌II（沙蟹總科）',
        publicationPlace: '',
        publisher: '國立中興大學',
        year: '',
      },
    ],
  },
  {
    id: '11',
    trivialName: '絨毛近方蟹',
    scientificName: 'Hemigrapsus penicillatus',
    taxonomy: '十足目 方蟹科',
    characteristic:
      '背甲呈方形，前側緣包含眼窩外齒共有三齒，體色多為暗褐色。螯足可動指多為紅褐色，雄蟹螯足可動指與不可動指的基部密佈絨毛，雌蟹與幼蟹則無此特徵。',
    distributionArea: '潮間帶的河口灘地或石礫堆周邊皆可發現。',
    img: macrobenthosImg11,
    photographer: '',
    reference: [
      {
        id: '11-1',
        category: '圖書',
        author: '王嘉祥、劉烘昌',
        title: '台灣海邊常見的螃蟹 Common seashore crabs of Taiwan',
        publicationPlace: '台北',
        publisher: '台灣省立博物館',
        year: '1996',
      },
      {
        id: '11-2',
        category: '圖書',
        author: '李榮祥',
        title: '台灣賞蟹情報',
        publicationPlace: '台北',
        publisher: '',
        year: '2008',
      },
      {
        id: '11-3',
        category: '圖書',
        author: '林惠真、宋文汀、蘇珊慧',
        title: '台中縣海岸濕地生態教室',
        publicationPlace: '台中',
        publisher: '',
        year: '2003',
      },
      {
        id: '11-4',
        category: '圖書',
        author: '林惠真、曾于芳',
        title: '話說高美',
        publicationPlace: '台中',
        publisher: '',
        year: '2014',
      },
      {
        id: '11-5',
        category: '圖書',
        author: 'Shih, H.T., Chan, B. K. K., Teng, S. J., Wong, K. J. H.',
        title: '台灣蟹類誌II（沙蟹總科）',
        publicationPlace: '',
        publisher: '國立中興大學',
        year: '',
      },
    ],
  },
  {
    id: '12',
    trivialName: '秀麗長方蟹',
    scientificName: 'Metaplax elegans',
    taxonomy: '十足目 方蟹科',
    characteristic:
      '背甲呈長方形，前側緣包含眼窩外齒共有四齒，且第二齒最明顯，體色多褐色或深紫色且有深色的斑紋。螯足等大，雄蟹的螯足與雌蟹相比較大且較長。',
    distributionArea: '河口潮間帶或紅樹林周邊較為泥濘的灘地皆可發現。',
    img: macrobenthosImg12,
    photographer: '',
    reference: [
      {
        id: '12-1',
        category: '圖書',
        author: '王嘉祥、劉烘昌',
        title: '台灣海邊常見的螃蟹 Common seashore crabs of Taiwan',
        publicationPlace: '台北',
        publisher: '台灣省立博物館',
        year: '1996',
      },
      {
        id: '12-2',
        category: '圖書',
        author: '李榮祥',
        title: '台灣賞蟹情報',
        publicationPlace: '台北',
        publisher: '',
        year: '2008',
      },
      {
        id: '12-3',
        category: '圖書',
        author: '林惠真、宋文汀、蘇珊慧',
        title: '台中縣海岸濕地生態教室',
        publicationPlace: '台中',
        publisher: '',
        year: '2003',
      },
      {
        id: '12-4',
        category: '圖書',
        author: '林惠真、曾于芳',
        title: '話說高美',
        publicationPlace: '台中',
        publisher: '',
        year: '2014',
      },
      {
        id: '12-5',
        category: '圖書',
        author: 'Shih, H.T., Chan, B. K. K., Teng, S. J., Wong, K. J. H.',
        title: '台灣蟹類誌II（沙蟹總科）',
        publicationPlace: '',
        publisher: '國立中興大學',
        year: '',
      },
    ],
  },
];

export const siteList = {
  macrobenthos: [
    {
      id: 'FYW01-1',
      longitude: 120.3127921,
      latitude: 23.9291414,
      cw: 47.73,
      particle: 0.03,
      sortCoefficient: 0.772,
      co: 2.61,
      soilPh: 7.47,
      soiltemp: 32.9,
      salinity: 32,
      species: '萬歲大眼蟹、淡水泥蟹、弧邊管招潮、北方丑招潮、斑點擬相手蟹',
    },
    {
      id: 'FYW01-2',
      longitude: 120.3030932,
      latitude: 23.9316519,
      cw: 29.09,
      particle: 0.18,
      sortCoefficient: 0.51,
      co: 0.98,
      soiltemp: 32,
      salinity: 32,
      soilPh: 7.63,
      species: '萬歲大眼蟹、淡水泥蟹、弧邊管招潮、北方丑招潮、斑點擬相手蟹',
    },
    {
      id: 'FYW02-1',
      longitude: 120.3098094,
      latitude: 23.9183046,
      cw: 59.3,
      particle: 0.03,
      sortCoefficient: 0.673,
      co: 3.53,
      soiltemp: 31,
      salinity: 35,
      soilPh: 7.55,
      species: '萬歲大眼蟹、淡水泥蟹、弧邊管招潮、北方丑招潮、斑點擬相手蟹',
    },
    {
      id: 'FYW02-2',
      longitude: 120.3001213,
      latitude: 23.920472,
      cw: 29.02,
      particle: 0.12,
      sortCoefficient: 1.241,
      co: 1.24,
      soiltemp: 32.8,
      salinity: 34,
      soilPh: 7.76,
      species: '萬歲大眼蟹、淡水泥蟹、弧邊管招潮、北方丑招潮、斑點擬相手蟹',
    },
    {
      id: 'FYW03',
      longitude: 120.3143692,
      latitude: 23.9316028,
      cw: 38.15,
      particle: 0.06,
      sortCoefficient: 1.706,
      co: 2.5,
      soiltemp: 34,
      salinity: 31,
      soilPh: 7.45,
      species: '萬歲大眼蟹、淡水泥蟹、弧邊管招潮、北方丑招潮、斑點擬相手蟹',
    },
  ],
  waterQuality: [
    {
      id: 'WG03',
      longitude: 120.3103781,
      latitude: 23.9486062,
      temperature: 25.91,
      ph: 7.92,
      orp: 217,
      conductivity: 36.3,
      turbidity: 15.57,
      dissolvedOxygen: 5.5,
      tds: 22.1,
      salinity: 22.9,
    },
    {
      id: 'WG04',
      longitude: 120.3147125,
      latitude: 23.9461745,
      temperature: 25.91,
      ph: 7.92,
      orp: 217,
      conductivity: 36.3,
      turbidity: 15.57,
      dissolvedOxygen: 5.5,
      tds: 22.1,
      salinity: 22.9,
    },
    {
      id: 'WG05',
      longitude: 120.3190899,
      latitude: 23.9436643,
      temperature: 25.91,
      ph: 7.92,
      orp: 217,
      conductivity: 36.3,
      turbidity: 15.57,
      dissolvedOxygen: 5.5,
      tds: 22.1,
      salinity: 22.9,
    },
    {
      id: 'WG06',
      longitude: 120.3196049,
      latitude: 23.9623719,
      temperature: 25.91,
      ph: 7.92,
      orp: 217,
      conductivity: 36.3,
      turbidity: 15.57,
      dissolvedOxygen: 5.5,
      tds: 22.1,
      salinity: 22.9,
    },
    {
      id: 'WG07',
      longitude: 120.3237677,
      latitude: 23.9599797,
      temperature: 25.91,
      ph: 7.92,
      orp: 217,
      conductivity: 36.3,
      turbidity: 15.57,
      dissolvedOxygen: 5.5,
      tds: 22.1,
      salinity: 22.9,
    },
    {
      id: 'WG08',
      longitude: 120.328145,
      latitude: 23.957509,
      temperature: 25.91,
      ph: 7.92,
      orp: 217,
      conductivity: 36.3,
      turbidity: 15.57,
      dissolvedOxygen: 5.5,
      tds: 22.1,
      salinity: 22.9,
    },
    {
      id: 'WG18',
      longitude: 120.3293467,
      latitude: 23.9830766,
      temperature: 25.91,
      ph: 7.92,
      orp: 217,
      conductivity: 36.3,
      turbidity: 15.57,
      dissolvedOxygen: 5.5,
      tds: 22.1,
      salinity: 22.9,
    },
    {
      id: 'WG19',
      longitude: 120.332222,
      latitude: 23.9821356,
      temperature: 25.91,
      ph: 7.92,
      orp: 217,
      conductivity: 36.3,
      turbidity: 15.57,
      dissolvedOxygen: 5.5,
      tds: 22.1,
      salinity: 22.9,
    },
    {
      id: 'WG20',
      longitude: 120.3381872,
      latitude: 23.9802534,
      temperature: 25.91,
      ph: 7.92,
      orp: 217,
      conductivity: 36.3,
      turbidity: 15.57,
      dissolvedOxygen: 5.5,
      tds: 22.1,
      salinity: 22.9,
    },
    {
      id: 'WG21',
      longitude: 120.3411913,
      latitude: 23.9792732,
      temperature: 25.91,
      ph: 7.92,
      orp: 217,
      conductivity: 36.3,
      turbidity: 15.57,
      dissolvedOxygen: 5.5,
      tds: 22.1,
      salinity: 22.9,
    },
    {
      id: 'WG22',
      longitude: 120.3227377,
      latitude: 23.9335445,
      temperature: 25.91,
      ph: 7.92,
      orp: 217,
      conductivity: 36.3,
      turbidity: 15.57,
      dissolvedOxygen: 5.5,
      tds: 22.1,
      salinity: 22.9,
    },
    {
      id: 'WG23',
      longitude: 120.330162,
      latitude: 23.9674308,
      temperature: 25.91,
      ph: 7.92,
      orp: 217,
      conductivity: 36.3,
      turbidity: 15.57,
      dissolvedOxygen: 5.5,
      tds: 22.1,
      salinity: 22.9,
    },
    {
      id: 'WG24',
      longitude: 120.3594732,
      latitude: 23.99084,
      temperature: 25.91,
      ph: 7.92,
      orp: 217,
      conductivity: 36.3,
      turbidity: 15.57,
      dissolvedOxygen: 5.5,
      tds: 22.1,
      salinity: 22.9,
    },
    {
      id: 'WG25',
      longitude: 120.3135109,
      latitude: 23.9292689,
      temperature: 25.91,
      ph: 7.92,
      orp: 217,
      conductivity: 36.3,
      turbidity: 15.57,
      dissolvedOxygen: 5.5,
      tds: 22.1,
      salinity: 22.9,
    },
  ],
};

export const contentList = {
  macrobenthos: [
    { id: 's_temp', title: '土溫', unit: '°C' },
    { id: 't_sal', title: '潮池鹽度', unit: 'ppt' },
    { id: 'cw', title: '土壤含水量', unit: '%' },
    { id: 'co', title: '土壤有機物含量', unit: '%' },
    { id: 's_ph', title: '土壤酸鹼值' },
    { id: 'mm', title: '粒徑中值', unit: 'mm' },
    { id: 'sc', title: '篩選度' },
    { id: 'macrobenthos', title: '蟹類' },
    // { id: 'cond', title: '電導度' },
    // { id: 'do', title: '溶氧' },
    // { id: 'w_sal', title: '鹽度' },
    // { id: 'tds', title: '總溶解固體物' },
    // { id: 'turb', title: '濁度' },
    // { id: 'orp', title: '氧化還原電位' },
  ],
  waterQuality: [
    { id: 'w_temp', title: '水溫', unit: '°C' },
    { id: 'w_ph', title: '酸鹼值', unit: '' },
    { id: 'phmv', title: '氫離子濃度', unit: 'mV' },
    { id: 'orp', title: '氧化還原電位', unit: 'mV' },
    { id: 'cond', title: '導電度', unit: 'mS/cm' },
    { id: 'turb', title: '濁度', unit: 'NTU' },
    { id: 'do', title: '溶氧', unit: 'mg/L' },
    { id: 'tds', title: '總固形物', unit: 'g/L' },
    { id: 'w_sal', title: '鹽度', unit: 'ppt' },
    { id: 'sg', title: '海水比重', unit: 'σt' },
  ],
};

export const filterMapList = [
  {
    id: 'macrobenthos',
    title: '底棲生物',
  },
  {
    id: 'water-quality',
    title: '水質監測',
  },
];

export const waterQualitySiteData = [
  {
    site: 'WG03',
    data: [
      {
        year: 2022,
        month: 2,
        data: {
          temperature: 17.38,
          ph: 8.1,
          phmv: -64,
          orp: 192.33,
          conductivity: 30.7,
          turbidity: 50.67,
          dissolvedOxygen: 8.09,
          tds: 18.8,
          salinity: 19,
          specificGravity: 13.3,
        },
      },
      {
        year: 2022,
        month: 3,
        data: {
          temperature: 23.19,
          ph: 7.62,
          phmv: -62.33,
          orp: 222,
          conductivity: 31.2,
          turbidity: 45.13,
          dissolvedOxygen: 3.8,
          tds: 19.1,
          salinity: 19.36,
          specificGravity: 12.23,
        },
      },
      {
        year: 2022,
        month: 4,
        data: {
          temperature: 27.93,
          ph: 8.03,
          phmv: -95,
          orp: 229.33,
          conductivity: 40.17,
          turbidity: 33.27,
          dissolvedOxygen: 7.38,
          tds: 24.5,
          salinity: 25.64,
          specificGravity: 15.57,
        },
      },
    ],
  },
  {
    site: 'WG04',
    data: [
      {
        year: 2022,
        month: 2,
        data: {
          temperature: 18.05,
          ph: 8.12,
          phmv: -65,
          orp: 204,
          conductivity: 31.67,
          turbidity: 32.57,
          dissolvedOxygen: 8.14,
          tds: 19.3,
          salinity: 19.6,
          specificGravity: 13.6,
        },
      },
      {
        year: 2022,
        month: 3,
        data: {
          temperature: 24.36,
          ph: 7.82,
          phmv: -74.33,
          orp: 224,
          conductivity: 30.5,
          turbidity: 63,
          dissolvedOxygen: 4.94,
          tds: 18.6,
          salinity: 18.89,
          specificGravity: 11.53,
        },
      },
      {
        year: 2022,
        month: 4,
        data: {
          temperature: 28.72,
          ph: 8.04,
          phmv: -96,
          orp: 220,
          conductivity: 31.43,
          turbidity: 35.47,
          dissolvedOxygen: 7.48,
          tds: 19.2,
          salinity: 19.55,
          specificGravity: 10.8,
        },
      },
    ],
  },
  {
    site: 'WG05',
    data: [
      {
        year: 2022,
        month: 2,
        data: {
          temperature: 18.77,
          ph: 8.06,
          phmv: -61.67,
          orp: 271.33,
          conductivity: 27.2,
          turbidity: 38.17,
          dissolvedOxygen: 7.84,
          tds: 16.9,
          salinity: 16.63,
          specificGravity: 11.2,
        },
      },
      {
        year: 2022,
        month: 3,
        data: {
          temperature: 23.93,
          ph: 7.91,
          phmv: -79.33,
          orp: 205.33,
          conductivity: 29.4,
          turbidity: 66.17,
          dissolvedOxygen: 6.7,
          tds: 18.2,
          salinity: 18.16,
          specificGravity: 11.1,
        },
      },
      {
        year: 2022,
        month: 4,
        data: {
          temperature: 29.08,
          ph: 8.02,
          phmv: -95,
          orp: 174,
          conductivity: 32.37,
          turbidity: 42.53,
          dissolvedOxygen: 6.63,
          tds: 19.73,
          salinity: 20.19,
          specificGravity: 11.13,
        },
      },
    ],
  },
  {
    site: 'WG06',
    data: [
      {
        year: 2022,
        month: 2,
        data: {
          temperature: 17.44,
          ph: 8.04,
          phmv: -61,
          orp: 187.67,
          conductivity: 27.87,
          turbidity: 72.5,
          dissolvedOxygen: 9.48,
          tds: 17.27,
          salinity: 17,
          specificGravity: 11.8,
        },
      },
      {
        year: 2022,
        month: 3,
        data: {
          temperature: 23.84,
          ph: 7.82,
          phmv: -74,
          orp: 229,
          conductivity: 30.1,
          turbidity: 57.93,
          dissolvedOxygen: 8,
          tds: 18.47,
          salinity: 18.66,
          specificGravity: 11.53,
        },
      },
      {
        year: 2022,
        month: 4,
        data: {
          temperature: 28.02,
          ph: 8.09,
          phmv: -99,
          orp: 221.33,
          conductivity: 40.47,
          turbidity: 44.77,
          dissolvedOxygen: 7.27,
          tds: 24.7,
          salinity: 25.86,
          specificGravity: 15.7,
        },
      },
    ],
  },
  {
    site: 'WG07',
    data: [
      {
        year: 2022,
        month: 2,
        data: {
          temperature: 17.56,
          ph: 8.02,
          phmv: -59,
          orp: 216.67,
          conductivity: 28.3,
          turbidity: 69.23,
          dissolvedOxygen: 9.92,
          tds: 17.53,
          salinity: 17.33,
          specificGravity: 12,
        },
      },
      {
        year: 2022,
        month: 3,
        data: {
          temperature: 23.74,
          ph: 7.8,
          phmv: -73,
          orp: 208.67,
          conductivity: 30.4,
          turbidity: 56.07,
          dissolvedOxygen: 7.44,
          tds: 18.5,
          salinity: 18.83,
          specificGravity: 11.7,
        },
      },
      {
        year: 2022,
        month: 4,
        data: {
          temperature: 28.87,
          ph: 8.05,
          phmv: -96.67,
          orp: 216.67,
          conductivity: 34.03,
          turbidity: 45.83,
          dissolvedOxygen: 7.65,
          tds: 20.77,
          salinity: 21.34,
          specificGravity: 12.1,
        },
      },
    ],
  },
  {
    site: 'WG08',
    data: [
      {
        year: 2022,
        month: 2,
        data: {
          temperature: 17.59,
          ph: 8.12,
          phmv: -65,
          orp: 232,
          conductivity: 26.8,
          turbidity: 60.43,
          dissolvedOxygen: 10.11,
          tds: 16.6,
          salinity: 16.3,
          specificGravity: 11.2,
        },
      },
      {
        year: 2022,
        month: 3,
        data: {
          temperature: 23.69,
          ph: 7.69,
          phmv: -66.67,
          orp: 174,
          conductivity: 29.6,
          turbidity: 53.77,
          dissolvedOxygen: 7.81,
          tds: 18.3,
          salinity: 18.28,
          specificGravity: 11.3,
        },
      },
      {
        year: 2022,
        month: 4,
        data: {
          temperature: 29.36,
          ph: 7.91,
          phmv: -88,
          orp: 202,
          conductivity: 30.57,
          turbidity: 49.77,
          dissolvedOxygen: 7.54,
          tds: 18.63,
          salinity: 18.94,
          specificGravity: 10.1,
        },
      },
    ],
  },
  {
    site: 'WG18',
    data: [
      {
        year: 2022,
        month: 2,
        data: {
          temperature: 16.91,
          ph: 8.2,
          phmv: -69,
          orp: 19,
          conductivity: 29.93,
          turbidity: 33.7,
          dissolvedOxygen: 8.59,
          tds: 18.6,
          salinity: 18.4,
          specificGravity: 13,
        },
      },
      {
        year: 2022,
        month: 3,
        data: {
          temperature: 23.28,
          ph: 7.69,
          phmv: -67,
          orp: 202.67,
          conductivity: 35.03,
          turbidity: 22.83,
          dissolvedOxygen: 3.65,
          tds: 21.37,
          salinity: 22,
          specificGravity: 14.17,
        },
      },
      {
        year: 2022,
        month: 4,
        data: {
          temperature: 28.42,
          ph: 8.03,
          phmv: -95,
          orp: 226,
          conductivity: 39.23,
          turbidity: 37.03,
          dissolvedOxygen: 7.17,
          tds: 23.93,
          salinity: 24.97,
          specificGravity: 14.9,
        },
      },
    ],
  },
  {
    site: 'WG19',
    data: [
      {
        year: 2022,
        month: 2,
        data: {
          temperature: 17.55,
          ph: 8.19,
          phmv: -69,
          orp: 40.67,
          conductivity: 28.9,
          turbidity: 49.97,
          dissolvedOxygen: 6.06,
          tds: 17.9,
          salinity: 17.7,
          specificGravity: 12.3,
        },
      },
      {
        year: 2022,
        month: 3,
        data: {
          temperature: 24.55,
          ph: 7.73,
          phmv: -69,
          orp: 188.33,
          conductivity: 29,
          turbidity: 44.9,
          dissolvedOxygen: 6.15,
          tds: 18,
          salinity: 17.9,
          specificGravity: 10.8,
        },
      },
      {
        year: 2022,
        month: 4,
        data: {
          temperature: 30.52,
          ph: 7.93,
          phmv: -89.33,
          orp: 207.33,
          conductivity: 33.43,
          turbidity: 30.93,
          dissolvedOxygen: 6.84,
          tds: 20.4,
          salinity: 20.92,
          specificGravity: 11.2,
        },
      },
    ],
  },
  {
    site: 'WG20',
    data: [
      {
        year: 2022,
        month: 2,
        data: {
          temperature: 17.76,
          ph: 8.14,
          phmv: -66.33,
          orp: 11,
          conductivity: 30.03,
          turbidity: 32.13,
          dissolvedOxygen: 8.64,
          tds: 18.37,
          salinity: 18.5,
          specificGravity: 12.87,
        },
      },
      {
        year: 2022,
        month: 3,
        data: {
          temperature: 25.36,
          ph: 7.9,
          phmv: -79,
          orp: 168.67,
          conductivity: 24.8,
          turbidity: 80.27,
          dissolvedOxygen: 7.13,
          tds: 15.37,
          salinity: 15.05,
          specificGravity: 8.4,
        },
      },
      {
        year: 2022,
        month: 4,
        data: {
          temperature: 30.59,
          ph: 7.79,
          phmv: -81.33,
          orp: 183,
          conductivity: 34.3,
          turbidity: 80.9,
          dissolvedOxygen: 6.36,
          tds: 20.9,
          salinity: 21.48,
          specificGravity: 11.6,
        },
      },
    ],
  },
  {
    site: 'WG21',
    data: [
      {
        year: 2022,
        month: 2,
        data: {
          temperature: 21.82,
          ph: 7.84,
          phmv: -50,
          orp: 45,
          conductivity: 16.1,
          turbidity: 120,
          dissolvedOxygen: 0.01,
          tds: 9.98,
          salinity: 9.4,
          specificGravity: 5.1,
        },
      },
      {
        year: 2022,
        month: 3,
        data: {
          temperature: 26.56,
          ph: 7.89,
          phmv: -79,
          orp: 198.67,
          conductivity: 18.9,
          turbidity: 87.87,
          dissolvedOxygen: 2.99,
          tds: 11.7,
          salinity: 11.22,
          specificGravity: 5.2,
        },
      },
      {
        year: 2022,
        month: 4,
        data: {
          temperature: 31.6,
          ph: 7.82,
          phmv: -83,
          orp: 91.67,
          conductivity: 28,
          turbidity: 249,
          dissolvedOxygen: 5.13,
          tds: 17.33,
          salinity: 17.17,
          specificGravity: 8.1,
        },
      },
    ],
  },
  {
    site: 'WG22',
    data: [
      {
        year: 2022,
        month: 2,
        data: {
          temperature: 19.41,
          ph: 7.89,
          phmv: -53,
          orp: 137.33,
          conductivity: 32.2,
          turbidity: 20.8,
          dissolvedOxygen: 8.1,
          tds: 19.6,
          salinity: 20,
          specificGravity: 13.6,
        },
      },
      {
        year: 2022,
        month: 3,
        data: {
          temperature: 25.91,
          ph: 7.92,
          phmv: -81,
          orp: 217,
          conductivity: 36.3,
          turbidity: 15.57,
          dissolvedOxygen: 5.5,
          tds: 22.1,
          salinity: 22.9,
          specificGravity: 14.1,
        },
      },
      {
        year: 2022,
        month: 4,
        data: {
          temperature: 30.02,
          ph: 8.15,
          phmv: -103,
          orp: 196,
          conductivity: 39.8,
          turbidity: 13.37,
          dissolvedOxygen: 7.89,
          tds: 24.3,
          salinity: 25.36,
          specificGravity: 14.7,
        },
      },
    ],
  },
  {
    site: 'WG23',
    data: [
      {
        year: 2022,
        month: 2,
        data: {
          temperature: 18.91,
          ph: 7.72,
          phmv: -43,
          orp: 139.33,
          conductivity: 28.07,
          turbidity: 12.5,
          dissolvedOxygen: 7.03,
          tds: 17.4,
          salinity: 17.2,
          specificGravity: 11.63,
        },
      },
      {
        year: 2022,
        month: 3,
        data: {
          temperature: 25.68,
          ph: 7.87,
          phmv: -78,
          orp: 229.67,
          conductivity: 33.9,
          turbidity: 26.63,
          dissolvedOxygen: 5.47,
          tds: 20.7,
          salinity: 21.27,
          specificGravity: 13,
        },
      },
      {
        year: 2022,
        month: 4,
        data: {
          temperature: 29.36,
          ph: 8.16,
          phmv: -103,
          orp: 215,
          conductivity: 42.57,
          turbidity: 18.83,
          dissolvedOxygen: 6.94,
          tds: 25.97,
          salinity: 27.35,
          specificGravity: 16.4,
        },
      },
    ],
  },
  {
    site: 'WG24',
    data: [
      {
        year: 2022,
        month: 2,
        data: {
          temperature: 21.31,
          ph: 8.14,
          phmv: -67,
          orp: 101,
          conductivity: 28.6,
          turbidity: 11.13,
          dissolvedOxygen: 7.21,
          tds: 17.7,
          salinity: 17.6,
          specificGravity: 11.33,
        },
      },
      {
        year: 2022,
        month: 3,
        data: {
          temperature: 26.83,
          ph: 8.3,
          phmv: -103,
          orp: 182,
          conductivity: 31.8,
          turbidity: 33.23,
          dissolvedOxygen: 7.52,
          tds: 19.4,
          salinity: 19.78,
          specificGravity: 11.5,
        },
      },
      {
        year: 2022,
        month: 4,
        data: {
          temperature: 29.66,
          ph: 8.08,
          phmv: -98.67,
          orp: 204.67,
          conductivity: 42.8,
          turbidity: 18.23,
          dissolvedOxygen: 6.76,
          tds: 26.1,
          salinity: 27.51,
          specificGravity: 16.4,
        },
      },
    ],
  },
  {
    site: 'WG25',
    data: [
      {
        year: 2022,
        month: 2,
        data: {
          temperature: 19.68,
          ph: 8,
          phmv: -59,
          orp: 139,
          conductivity: 32.37,
          turbidity: 13.6,
          dissolvedOxygen: 9.07,
          tds: 19.7,
          salinity: 20.1,
          specificGravity: 13.67,
        },
      },
      {
        year: 2022,
        month: 3,
        data: {
          temperature: 26.92,
          ph: 8.37,
          phmv: -107.33,
          orp: 192.67,
          conductivity: 37.3,
          turbidity: 10.15,
          dissolvedOxygen: 12.04,
          tds: 22.8,
          salinity: 23.64,
          specificGravity: 14.4,
        },
      },
      {
        year: 2022,
        month: 4,
        data: {
          temperature: 30.44,
          ph: 8.28,
          phmv: -110.33,
          orp: 197.33,
          conductivity: 41.9,
          turbidity: 12.23,
          dissolvedOxygen: 7.27,
          tds: 25.57,
          salinity: 26.86,
          specificGravity: 15.7,
        },
      },
    ],
  },
];

export const macrobenthosNameList = [
  {
    id: 'Mbr',
    title: '短指和尚蟹',
  },
  {
    id: 'Mb',
    title: '萬歲大眼蟹',
  },
  {
    id: 'Ma',
    title: '短身大眼蟹',
  },
  {
    id: 'Hf',
    title: '台灣厚蟹',
  },
  {
    id: 'Hd',
    title: '德氏仿厚蟹',
  },
  {
    id: 'Hp',
    title: '絨毛近方蟹',
  },
  {
    id: 'Me',
    title: '秀麗長方蟹',
  },
  {
    id: 'Sb',
    title: '雙扇股窗蟹',
  },
  {
    id: 'Sl',
    title: '長趾股窗蟹',
  },
  {
    id: 'It',
    title: '淡水泥蟹',
  },
  {
    id: 'Oc',
    title: '斯氏沙蟹',
  },
  {
    id: 'Al',
    title: '乳白南方招潮蟹',
  },
  {
    id: 'Ta',
    title: '弧邊管招潮蟹',
  },
  {
    id: 'Gb',
    title: '北方丑招潮蟹',
  },
  {
    id: 'Xf',
    title: '台灣旱招潮蟹',
  },
  {
    id: 'Pa',
    title: '近親擬相手蟹',
  },
  {
    id: 'Pp',
    title: '豆形拳蟹',
  },
  {
    id: 'Tc',
    title: '鈍齒短槳蟹',
  },
  {
    id: 'Ppi',
    title: '斑點擬相手蟹',
  },
  {
    id: 'Mv',
    title: '勝利黎明蟹',
  },
  {
    id: 'Charybids_sp',
    title: '蟳 sp.',
  },
  {
    id: 'Mt',
    title: '絨毛大眼蟹',
  },
  {
    id: 'Pb',
    title: '雙齒近相手蟹',
  },
  {
    id: 'Mth',
    title: '雙齒近相手蟹',
  },
];

export const airQualitySiteItemList = [
  {
    id: 1,
    title: '二林',
    position: [23.925175, 120.409653],
    list: [
      'AMB_TEMP',
      'CH4',
      'CO',
      'NMHC',
      'NO',
      'NO2',
      'NOx',
      'O3',
      'PM10',
      'PM2.5',
      'RAINFALL',
      'RH',
      'SO2',
      'THC',
      'WD_HR',
      'WIND_DIREC',
      'WIND_SPEED',
      'WS_HR',
    ],
    url: '&filters=SiteName,EQ,二林%7Citemengname,EQ,AMB_TEMP,CH4,CO,NMHC,NO,NO2,NOx,O3,PM10,PM2.5,RAINFALL,RH,SO2,THC,WD_HR,WIND_DIREC,WIND_SPEED,WS_HR',
  },
  {
    id: 2,
    title: '大城',
    position: [23.85493056, 120.26964167],
    list: [
      'CH4',
      'CO',
      'O3',
      'PM2.5',
      'RAINFALL',
      'RH',
      'SO2',
      'WD_HR',
      'WS_HR',
    ],
    url: '&filters=SiteName,EQ,大城%7Citemengname,EQ,CH4,CO,O3,PM2.5,RAINFALL,RH,SO2,WD_HR,WS_HR',
  },
];
